import { Box, Flex, Heading, Text, Icon, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { LuPencilLine } from "react-icons/lu";

const DiaryBanner = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/new-diary");
  };

  return (
    <Box
      bg="teal.100"
      p={6}
      borderRadius="lg"
      boxShadow="md"
      _hover={{ bg: "teal.200", cursor: "pointer" }}
      onClick={handleClick}
    >
      <Flex align="center" gap={4}>
        <Icon as={LuPencilLine} boxSize={8} color="teal.700" />
        <Box>
          <Heading size="md" color="teal.800">
            Start Today's Diary
          </Heading>
          <Text color="teal.700">
            Click here to write down your thoughts and moments!
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};

export default DiaryBanner;
